import {
  CASE_AUDIT_ADD_NEW,
  CASE_AUDIT_ADD_NEW_SUCCESS,
  CASE_AUDIT_ADD_NEW_ERROR,
  CASE_AUDIT_EDIT,
  CASE_AUDIT_EDIT_SUCCESS,
  CASE_AUDIT_EDIT_ERROR,
  CASE_AUDIT_GET_BY_QUERY,
  CASE_AUDIT_GET_BY_ID,
  CASE_AUDIT_GET_BY_ID_SUCCESS,
  CASE_AUDIT_GET_BY_ID_ERROR,
  CASE_AUDIT_GET_BY_QUERY_SUCCESS,
  CASE_AUDIT_GET_BY_QUERY_ERROR,
  CASE_AUDIT_ADD_NEW_REQUEST,
  CASE_AUDIT_DELETE,
  CASE_AUDIT_DELETE_ERROR,
} from './types';
// item
const initialState = {
  item: null,
  items: [],
  loading: false,
  error: null,
  itemCount: 0,
  pageCount: 0,
  total: 0,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default function initState(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CASE_AUDIT_ADD_NEW:
    case CASE_AUDIT_DELETE:
    case CASE_AUDIT_GET_BY_ID:
    case CASE_AUDIT_GET_BY_QUERY:
      return {
        ...state,
        loading: true,
        error: null,
        deleteSuccess: true,
        addSuccess: true,
        editSuccess: false,
        item: null,
      };

    case CASE_AUDIT_EDIT:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: true,
      };
    case CASE_AUDIT_EDIT_SUCCESS:
    case CASE_AUDIT_ADD_NEW_REQUEST:
      return {
        ...state,
        loading: false,
        item: null,
        error: null,
      };
    case CASE_AUDIT_ADD_NEW_SUCCESS:
    case CASE_AUDIT_GET_BY_QUERY_SUCCESS:
      const { itemCount, pageCount, total, data } = payload;
      return {
        ...state,
        loading: false,
        items: data,
        total,
        itemCount,
        pageCount,
      };

    case CASE_AUDIT_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
      };

    case CASE_AUDIT_ADD_NEW_ERROR:
    case CASE_AUDIT_DELETE_ERROR:
    case CASE_AUDIT_EDIT_ERROR:
    case CASE_AUDIT_GET_BY_ID_ERROR:
    case CASE_AUDIT_GET_BY_QUERY_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
}
